module.exports = __webpack_public_path__ + "media/images/join-us-on-slack-9a12b67edba3214126878e727ac400ed.png";